<template>
    <div id="faq">
    <!------------------------------常見問題------------------------------>
    <section class="cm-customercenter-faq-section">
            <div class="container-fluid p-0">
                <div class="row no-gutters">
                    <div class="col">
                        <img class="img-fluid" :src=imageUrl>
                    </div>
                </div>
            </div>


            <div class="d-flex align-items-start justify-content-center mb-4 cm-triangle">
                <div class="cm-triangle-font">
                    {{$t('faq.title')}}
                </div>
            </div>
		
		
		<div class="cm-customercenter-faq-container">
            <form id="queryForm">
            <div class="form-group row">
                <select v-if="!isGameListEmpty" v-model="selectedGameCode" @click="initData(3)" :label="gameLabel" class="form-control form-control-lg cm-customercenter-faq-select">
                    <option value="null">{{$t('faq.Item.GameSelect')}}</option>                    
                    <option v-for="(obj, index) in gameCodeAndName" :key="index" :value="obj.gameCode">{{obj.gameName}}</option>
                    <option value="common">{{$t('faq.Item.Select.Option.common')}}</option>
                </select>
			</div>

            <div v-show="selectedGameCode!=='null'&&selectedGameCode!==''" style="display:none;">
                <div class="cm-customercenter-faq-tab row px-sm-5 px-0">
                    <a @click.prevent="showQueryTab()" class="cm-customercenter-faq-tab-btn col-6 px-0">{{$t('faq.Item.QueryTab')}}</a>
                    <a @click.prevent="showSearchTab()" class="cm-customercenter-faq-tab-btn col-6 px-0">{{$t('faq.Item.SearchTab')}}</a>
                </div>
                <div id="selectFaqDiv" class="form-group row"  style="display:block;">
                    <select id="queryType" v-model="selectedQueryType" :label="queryLabel" @change="onQueryTypeSelect" class="form-control form-control-lg cm-customercenter-faq-select">
                        <option value="null">{{$t('contactus.Item.QuestionType')}}</option>
                        <option value="bugs">1.{{$t('faq.Item.Select.Option.bugs')}}</option>
                        <option value="report">2.{{$t('faq.Item.Select.Option.report')}}</option>
                        <option value="deposit">3.{{$t('faq.Item.Select.Option.deposit')}}</option>
                        <option value="account">4.{{$t('faq.Item.Select.Option.account')}}</option>
                        <option value="login">5.{{$t('faq.Item.Select.Option.login')}}</option>
                        <option value="game">6.{{$t('faq.Item.Select.Option.game')}}</option>
                        <option value="other">7.{{$t('faq.Item.Select.Option.other')}}</option>
                    </select>
                </div>
                <div id="searchFaqDiv" class="form-group row" style="display:none;">
                    <div class="col-sm-12 row no-gutters">
                        <input v-model="searchKeyWord" type="text" class="col-8 cm-customercenter-faq-input" :placeholder="$t('faq.Item.SearchHolder')" />
                        <a id="searchFaqBtn" class="cm-customercenter-faq-send-btn" @click.prevent="onSendBtnClick()">{{$t('faq.Item.SendSearch')}}</a>
                    </div>
                <!-- end of 上方搜尋/選擇區塊 -->
                </div>
			</div>
            
            <!-- 搜尋FAQ表單 -->
			</form>
			
            <div v-show="selectedGameCode!=='null'&&selectedGameCode!==''" style="display:none;">
                <div v-show="ajax.faqResponse.length>=1">
                    <div class="cm-customercenter-faq-QA_Box my-3 py-1" style=" display:block;"
                        v-for="(ele, index) in ajax.faqResponse" :key="index">
                        <div class="cm-customercenter-faq-question" @click.prevent="faqAnsweSlideToggle(index)">
                            <a class="cm-customercenter-faq-questionText">
                                <div class="Question_title"></div>
                                <span class="QuestionText">{{ele.title}}</span>
                            </a>
                        </div>
                        <div class="cm-customercenter-faq-answer" style="display:none;">
                            <div class="cm-customercenter-faq-answerText">
                                <p v-html="ele.content"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="ajax.faqResponse.length==0" class="cm-customercenter-faq-QA_Box">
                    <div class="cm-customercenter-faq-question">
                        <a class="cm-customercenter-faq-questionText">
                            <div class="Question_title"></div>
                            <span class="QuestionText">{{$t('faq.message.BeforeSearch')}}</span>
                        </a>
                    </div>
                </div>
            </div>

        </div>
        <!-- end of container -->
        <br />

        <div class="cm-customercenter-faq-banner-line"></div>
        </section>
    <!-------------------------------常見問題------------------------------->				
    </div>
</template>

<script>
import $ from 'jquery';
import * as BackendSetting from "@/assets/js/util/BackendSetting.js";
import eventBus from '@/assets/js/event/EventBus.js';
import axios from 'axios';
import zenDesk from '@/assets/js/util/zenDesk.js';

export default {
    name:"faq",
    data() {
        return {
            gameCodeAndName: [],
            faqList: [],
            selectedGameCode: "null", // 選擇要查詢的遊戲
            selectedQueryType: "null", //選擇要查詢的問題類別
            searchKeyWord: "", //輸入的查詢用關鍵字
            imageUrlDefault: require("@/assets/images/game/gametitle.jpg"),
            imageUrl: require("@/assets/images/game/gametitle.jpg"),
            queryLabel: this.$i18n.t('contactus.Item.QuestionType'),
            gameLabel: this.$i18n.t('faq.Item.GameSelect'),
            ajax: {
                faqResponse: [
                    //{title: "標題", content: "內容"}
                ]
            },
            languageCode: this.$i18n.locale
        };
    },
    created() {
        //window.location.href= "https://all9funsupport.zendesk.com/hc";
        this.initGameList();
    },
    mounted() {
        this.updateTopBackgroundImg();
        // 更換語言時
        const self = this;
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_FAQ, function(i18n) {            
            self.languageCode = i18n.locale;
            self.updateTopBackgroundImg(i18n);
            self.initData(5);
        });

        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_SWITCH_PAGE_SHOW_ITEMS , false);
    },
    methods: {
        initData(level) {
            if(level>=5) {
                this.gameCodeAndName = [];                
                this.$nextTick(function (){
                    this.initGameList();
                });
            }
            if(level>=4) this.selectedGameCode = "null";
            if(level>=3) this.selectedQueryType = "null";
            if(level>=2) this.ajax.faqResponse = [];
        },
        async updateTopBackgroundImg(i18n = this.$i18n) {
            // 更新上方背景圖
            let imageUrl = await BackendSetting.getTopBackgroundImgUrl(i18n.locale);
            this.imageUrl = (imageUrl != "" ? imageUrl : this.imageUrlDefault);
        },
        faqAnsweSlideToggle(index) {                        
            const ele = $(".cm-customercenter-faq-answer").get(index);
            if ($(ele).is(":visible")){
                $(ele).slideToggle("0.5");
            }
            else {
                $(".cm-customercenter-faq-answer:visible").hide();
                $(ele).slideToggle("0.5");
            }
        },        
        initGameList(){
            this.gameCodeAndName = [];            
            let self = this;
            var paramCode;
                        
            if(this.$route.query.gameCode!==undefined) {
                paramCode = this.$route.query.gameCode;
            }

            var testForm = new FormData();
            testForm.append("languageCode" , this.languageCode);
            
            axios({
                    method: "post",
                    url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/frontendGetActiveHaveFaqMobileGameListAction.shtml",
                    data: testForm,
                    timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                    config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                })
                .then(function(response) {
                    var data = response.data;
                    
                    if(data.status == 'success')
                    {
                        for (let i=0;i <data.gameList.length;i++){
                            let game = {
                                gameCode : data.gameList[i].gameCode,
                                gameName : data.gameList[i].gameName
                            }
                            self.gameCodeAndName.push(game);
                        }                
                        if (paramCode){
                            for (let i=0;i<self.gameCodeAndName.length;i++){
                                if (self.gameCodeAndName[i].gameCode == paramCode){
                                    self.selectedGameCode = paramCode;
                                }
                            }
                        }
                    }else{
                        alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                    }
                })
                .catch(function () {
                    alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                });
        },
        onQueryTypeSelect(){
            let self = this;

            if (this.selectedGameCode == 'null' || this.selectedGameCode == ''){
                alert(this.$i18n.t('faq.message.PleaseSelectGame'));
                this.initData(3)
                return false;
            }

            if (this.selectedQueryType != 'null' || this.selectedQueryType != ''){
                let bodyFormData = new FormData();
                bodyFormData.append('gameCode' ,this.selectedGameCode);
                bodyFormData.append('queryType' , this.selectedQueryType);
                bodyFormData.append('languageCode' , this.languageCode);
                
                axios({
                    method: "post",
                    url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getSdkFaqListByQueryTypeJsonAction.shtml",
                    data: bodyFormData,
                    timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                    config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                })
                .then(function(response) {
                    var data = response.data;
                    if(data.status == 'success')
                    {
                        self.buildQandABox(data.faqContent);
                    }
                    else
                    {
                        alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                    }
                })
                .catch(function () {
                    alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                });
            }
        },
        onSendBtnClick(){
            let self = this;

            if (this.selectedGameCode == 'null' || this.selectedGameCode == ''){
                alert(this.$i18n.t('faq.message.PleaseSelectGame'));
                return false;
            }

            if (this.searchKeyWord != 'null' || this.searchKeyWord != ""){
                let bodyFormData = new FormData();
                bodyFormData.append('gameCode' ,this.selectedGameCode);
                bodyFormData.append('keyWord' , this.searchKeyWord);
                bodyFormData.append('languageCode' , this.languageCode);

                axios({
                    method: "post",
                    url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getSdkFaqListByKeyWordSearchJsonAction.shtml",
                    data: bodyFormData,
                    timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                    config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                })
                .then(function(response) {
                    var data = response.data;
                    if(data.status == 'success')
                    {
                        self.buildQandABox(data.faqContent);
                    }
                    else
                    {
                        alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                    }
                })
                .catch(function () {
                    alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                });
            }else{
                alert(self.$i18n.t('faq.message.PleaseEnterKeyWord'));
            }
        },
        showQueryTab(){
            $("#selectFaqDiv").show();
            $("#searchFaqDiv").hide();
        },
        showSearchTab(){
            $("#selectFaqDiv").hide();
            $("#searchFaqDiv").show();
        },
        buildQandABox(inputData){
            this.initData(2);
            let self = this;
            let data = inputData;
            
            if (data == 'undefined' || data == null || data.length == 0){
                this.ajax.faqResponse.push({
                    "title": this.$i18n.t('faq.message.SearchResultEmpty'),
                    "content": this.$i18n.t('faq.message.SearchResultEmpty')
                });
            }else{
                for (let i = 0 ; i < data.length ; i++){
                    let content = data[i].nodeContent
                    if (content.indexOf("[a]") > -1){
                        content = content.replaceAll('[a]' , '<a>');
                    }
                    if (content.indexOf("[/a]") > -1){
                        content = content.replaceAll('[/a]' , '</a>');
                    }
                    if (content.indexOf("[b]") > -1){
                        content = content.replaceAll('[b]' , '<br/>');
                    }
                    if (content.indexOf("[i]") > -1){
                        content = content.replaceAll('[i]' , '<img src="');
                    }
                    if (content.indexOf("[/i]") > -1){
                        content = content.replaceAll('[/i]' , '"/>');
                    }

                    this.ajax.faqResponse.push({
                        "title": data[i].nodeName,
                        "content": content
                    });
                }
            }
            self.$nextTick(function (){
                self.parseNodeContent();
            });
        },
        parseNodeContent(){
            var urlLinks = $(".cm-customercenter-faq-answer").find("a");
            for (let i = 0; i < urlLinks.length; i++) {
                urlLinks[i].href =  $(urlLinks[i]).html();
                urlLinks[i].target = "_blank";
            }
        }
    },
    compute:{
        isGameListEmpty: function(){
            return (this.gameCodeAndName.length == 0);
        }
    }
}
</script>